import { LeaveDialog } from './LeaveDialog';

/**
 * @deprecated Import LeaveDialog from /containers/LeaveDialogue/LeaveDialog
 */
export default LeaveDialog;
